<h3 *ngIf="isDefault()">Cadastrar Novo Cutoff Padrão</h3>
<h3 *ngIf="isException() && cutoffType != null">
  Solicitar atualização horário limite - {{ cutoffType.description }}
</h3>

<form #thisForm="ngForm" (ngSubmit)="submit()">
  <div class="card mt-3">
    <div class="card-header text-uppercase">
      <span *ngIf="isDefault()">Horário Limite Padrão</span>
      <span *ngIf="isException()">Horário Limite Exceção</span>
    </div>
    <div class="card-body">
      <div class="row mb-2">
        <div class="col-12" *ngIf="isDefault()">
          <label>Tipo de Cutoff</label>
          <ng-select
            [items]="cutoffTypeList"
            bindLabel="description"
            bindValue="id"
            name="cutoffType"
            [(ngModel)]="model.ticketCutoffType"
            (change)="getCutoffDefaultLimitTime()"
            class="ng-invalid ng-touched ng-prestine"
          >
          </ng-select>
        </div>

        <div class="col-12">
          <label>Gestora</label>
          <ng-select
            [multiple]="true"
            [closeOnSelect]="false"
            [clearSearchOnAdd]="true"
            [items]="accountManagerList"
            bindLabel="name"
            bindValue="id"
            notFoundText="Selecione um tipo de cutoff para continuar..."
            [(ngModel)]="selectedAccountManagerList"
            [ngModelOptions]="{ standalone: true }"
            (change)="selectedAccountManagerChanged()"
            (remove)="removeSelectedFundsFromRemovedAccountManager($event)"
            (clear)="clearSelectedAccountManagerFund()"
            [disabled]="disableSelect()"
            required
          >
            <ng-template
              ng-option-tmp
              let-item="item"
              let-item$="item$"
              let-index="index"
            >
              <input
                id="item-{{ index }}"
                type="checkbox"
                [ngModel]="item$.selected"
                [ngModelOptions]="{ standalone: true }"
                name="accManagerSel-{{ index }}"
              />
              {{ item.document }} {{ item.name }}
            </ng-template>
          </ng-select>
          <div *ngIf="accountManagerError != null" class="alert-warning">
            <ul>
              <li *ngFor="let item of accountManagerError">
                {{ item.message }}
              </li>
            </ul>
          </div>
        </div>

        <div class="col-12">
          <label>Fundo</label>
          <ng-select
            [multiple]="true"
            [closeOnSelect]="false"
            [clearSearchOnAdd]="true"
            [items]="fundList"
            bindLabel="name"
            bindValue="id"
            notFoundText="Selecione um gestor para continuar..."
            groupBy="manager"
            [(ngModel)]="selectedFundList"
            [ngModelOptions]="{ standalone: true }"
            (change)="selectedFundChanged()"
            [disabled]="disableSelect()"
          >
            <ng-template ng-optgroup-tmp let-item="item" let-index="index">
              {{ item.manager }}
            </ng-template>
            <ng-template
              ng-option-tmp
              let-item="item"
              let-item$="item$"
              let-index="index"
            >
              <input
                id="item-{{ index }}"
                type="checkbox"
                [ngModel]="item$.selected"
                [ngModelOptions]="{ standalone: true }"
                name="accManagerSel-{{ index }}"
                [disabled]="item.disabled"
              />
              {{ item.document }} {{ item.name }}
            </ng-template>
          </ng-select>
        </div>

        <div class="row mb-2 col-12">
          <div class="col-3">
            <label for="timeLimit">Horário Limite</label>
            <input
              type="time"
              class="form-control"
              id="timeLimit"
              name="timeLimit"
              placeholder="horário limite"
              pattern="[0-9]{2}:[0-9]{2}"
              required
              [(ngModel)]="model.timeLimit"
            />
            <div
              *ngIf="
                this.model.timeLimit != null &&
                isException() &&
                !isTimeLimitValid()
              "
              class="alert alert-danger"
            >
              <div *ngIf="!isTimeLimitValid()">
                Horário limite deve ser maior que horário atual.
              </div>
            </div>
          </div>
        </div>

        <div class="col-12" *ngIf="isException()">
          <div class="col-12">
            <label for="justificative">Justificativa</label>
            <textarea
              class="form-control"
              id="justificative"
              name="justificative"
              placeholder="Justificativa"
              [(ngModel)]="model.justificative"
              rows="3"
              required
            ></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="actions">
    <input
      type="button"
      value="Solicitar"
      class="btn btn-primary"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
    />
  </div>

  <div>
    <table
      *ngIf="history && history.length > 0"
      class="table table-striped table-hover"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Data</th>
          <th scope="col">Usuário</th>
          <th scope="col">Horário Limite</th>
          <th scope="col">Justificativa</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of history">
          <td>{{ item.creationDate | date: "dd/MM/yyyy HH:mm:ss" }}</td>
          <td>{{ item.creationUser }}</td>
          <td>{{ item.timeLimit | date: "HH:mm":"-0300" }}</td>
          <td>{{ item.justificative }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</form>
